<div class="partner-contracts__header">
  <div>
    <h3 class="partner-contracts__title">Contratos de parceria</h3>
    <p class="partner-contracts__subtitle">
      Cada contrato nasce do modelo vigente e depois é editado à parte: mudar o modelo não altera os
      contratos já gerados.
    </p>
  </div>

  @if (canCreate()) {
    <app-button
      label="Gerar contrato"
      icon="pi pi-file-edit"
      (sendButtonClick)="openGenerateModal()" />
  }
</div>

<!-- Lista vazia: só o aviso de baixo (a tabela vazia repetiria "Nenhum item encontrado").
     `getOptionsFunction` com binding condicional: o `app-table` decide se mostra a coluna de ações
     pelo binding, não pelo que a função devolve (mesma régua da listagem de parceiros).
     O `app-table` acha cada template pelo `field` da coluna: o nome do `appNamedTemplate` tem de ser
     igual ao `field` (com outro nome, a célula mostra o valor cru).
-->
@if (loading() || contracts().length) {
  <app-table
    [items]="contracts()"
    [columnDefinitions]="columnDefinitions"
    [loading]="loading()"
    [hasPagination]="contracts().length > 10"
    [inMemoryPagination]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [getOptionsFunction]="hasRowActions() ? rowActions.bind(this) : undefined"
    (sendRowClick)="openEditor($event)">
    <ng-template appNamedTemplate="contractNumber" let-item>
      {{ contractNumber(item) }}
    </ng-template>

    <ng-template appNamedTemplate="templateVersion" let-item>
      <span class="partner-contracts__version">v{{ item.templateVersion }}</span>
    </ng-template>

    <ng-template appNamedTemplate="partyType" let-item>
      <span class="partner-contracts__type" [pTooltip]="partyTypeLabel(item.partyType)">
        {{ partyTypeLabel(item.partyType, true) }}
      </span>
    </ng-template>

    <ng-template appNamedTemplate="status" let-item>
      <span class="contract-status" [class.contract-status--finalized]="isFinalized(item.status)">
        {{ statusLabel(item.status) }}
      </span>
    </ng-template>

    <ng-template appNamedTemplate="unfilledVariablesCount" let-item>
      @if (item.unfilledVariablesCount > 0) {
        <span class="partner-contracts__pending" pTooltip="Variáveis ainda sem valor no texto">
          <i class="pi pi-exclamation-triangle"></i>
          {{ item.unfilledVariablesCount }}
          {{ item.unfilledVariablesCount === 1 ? 'dado faltando' : 'dados faltando' }}
        </span>
      } @else {
        <span class="partner-contracts__complete"><i class="pi pi-check"></i> Completo</span>
      }
      @if (item.outOfDefaultCount > 0) {
        <span
          class="partner-contracts__off-default"
          pTooltip="Percentual diferente do padrão: o envio vai pedir aprovação">
          Fora do padrão
        </span>
      }
    </ng-template>
  </app-table>
}

@if (!loading() && !contracts().length) {
  <div class="partner-contracts__empty">
    <i class="pi pi-file"></i>
    <p>
      Nenhum contrato gerado para este parceiro.
      @if (canCreate()) {
        Use <strong>Gerar contrato</strong> para criar a minuta a partir do modelo.
      }
    </p>
  </div>
}

<app-modal-generate-partner-contract #generateModal (generated)="onGenerated($event)" />
